/** 工具 */
import { getStore } from '@/util/store'
const userInfo = getStore({ name: 'userInfo' }) // 获取 userInfo

// 判断是有老师身份
export const isTeacher = () => {
  return userInfo.memberType ? userInfo.memberType?.some((role) => role === 'teacher') : false
}
// 判断是学生身份
export const isStudent = () => {
  return userInfo.memberType?.length === 1 && userInfo.memberType[0] === 'student'
}
